export const buildVer = 'cf5437bd618345cd78d7f2e2632f41e5edbb45b7';
export const darklyClientId = '661f55c9ef6a230f53c34475';
